
export const Theme = {
  container: 'fixed z-[999999] space-y-4 top-24 inset-x-1/3',
}
